<template>
  <div id="appproductorders">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col cols="12" md="12">
          <TeacherProductOrders />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import TeacherProductOrders from "@/components/app-components/teacher/TeacherProductOrders.vue";

export default {
  name: "AppProductOrdersView",
  components: { TeacherProductOrders },
  data: () => ({}),
};
</script>
